import React from 'react';
import styles from '../irlObservations2026.module.css';
import { DetailHeader, DetailTabs, IrlCounts } from './shared';

export default function IRL_History({ request, tab, onTab, onBack, onOpenAi, onCopy, copied, tabs, extraActions, onUpdateFields, busy }) {
    return (
        <>
            <DetailHeader kind="irl" item={request} onBack={onBack} onOpenAi={onOpenAi} onCopy={onCopy} copied={copied} extraActions={extraActions} onUpdateFields={onUpdateFields} busy={busy} />
            <DetailTabs tabs={tabs} tab={tab} onTab={onTab} counts={IrlCounts(request)} />
            <div className={styles.detailBody}>
                <div className={styles.detailInner}>
                    {(request.history || []).map(item => (
                        <div key={`${item.date}-${item.title}`} className={styles.historyItem}>
                            <div className={styles.historyDate}>{item.date}</div>
                            <div>
                                <div className={styles.historyTitle}>{item.title}</div>
                                <div className={styles.historyDetail}>{item.detail}</div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
}
